import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-user-disabled',
  imports: [RouterLink],
  templateUrl: './user-disabled.html',
  styleUrl: './user-disabled.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDisabled {}
